/* eslint-disable @angular-eslint/directive-selector */
import {
    Directive,
    AfterViewInit,
    ElementRef
} from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

@Directive({
    selector: 'p-inputNumber[spinnerTooltip]'
})
export class GlobalInputNumberSpinnerTooltipDirective implements AfterViewInit {

    constructor(private el: ElementRef) { }

    ngAfterViewInit() {
        const observer = new MutationObserver(() => {
            const host = this.el.nativeElement;

            const up = host.querySelector('.p-inputnumber-button-up');
            const down = host.querySelector('.p-inputnumber-button-down');

            if (up && !up.hasAttribute('title')) {
                up.setAttribute('title', 'Incrementar');
            }

            if (down && !down.hasAttribute('title')) {
                down.setAttribute('title', 'Decrementar');
            }
        });

        observer.observe(this.el.nativeElement, {
            childList: true,
            subtree: true
        });
    }
}
